	<ng-container *ngIf="isQuizLoading else quizPageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>
<ng-template #quizPageContent>
  <div class="quiz-header">
	<div class="d-flex">
	<h2>Manage Quizzes</h2>
    <span class="count-badge ms-2 mt-1">{{ _totalQuizCount }}</span>
	</div>
    <div class="filter-create">

      <div class="filter-dropdown">
        <button (click)="toggleFilter()" class="filter-btn">
          <i class="bi bi-filter"></i> {{ selectedQuizFilter }}
        </button>
        <div class="dropdown" *ngIf="filterOpen">
          <label *ngFor="let status of courseStatuses">
            <input type="radio" name="filter" 
                   [checked]="selectedQuizFilter === status" 
                   (change)="onFilterChange(status, StudyMaterialTypeEnum.Quiz)" /> 
            {{ status }}
          </label>
        </div>
      </div>
	  
	 <div class="custom-modal" (click)="$event.stopPropagation()" *ngIf="isModalOpen">
			<form [formGroup] = "quizForm">
              <div class="modal-header">
                <h4 class="create-account text-center">Create New Quiz</h4>
                <button class="close-btn" (click)="closeModal()">
                </button>
              </div>

              <div class="modal-body">
                <label for="quizTitle">Quiz Title</label>
                <input 
				id="quizTitle" 
				class="quiz-input mb-2" 
				type="text" 
				formControlName="quiz_name"
                placeholder="Enter Your Quiz Title" />

				  <label for="quizTitle">Time Limit</label>
                  <div class="time-limit-section">
                    <div class="time-inputs">
                      <div class="time-field mb-2">
                        <input type="number" min="0" placeholder="00" formControlName="hours" />
                        <span>Hrs</span>
                      </div>
                      <div class="time-field mb-2">
                        <input type="number" min="0" placeholder="00" max="60" formControlName="minutes"/>
                        <span>Min</span>
                      </div>
                      <div class="time-field mb-2">
                        <input type="number" min="0" placeholder="00"  max="60" formControlName="seconds" />
                        <span>Sec</span>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="modal-footer">
                <button class="cancel-btn" (click)="closeModal()">Cancel</button>
                <button class="create-btn" (click)="createQuiz()" [disabled]="quizForm.invalid || isCreating">
				<ng-container *ngIf="isCreating; else noCreating">
					 <span class="spinner-text">
                          <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>
                          Creating...</span>
						</ng-container>
						<ng-template #noCreating>
					<i class="bi bi-plus"></i>Create Quiz
				</ng-template></button>
              </div>
			  </form>
            </div> 
	  <button class="create-btn" (click)="openModal()">
    <i class="bi bi-plus"></i> Create Quiz
  </button>
    </div>
  </div>

	<div *ngIf="_quizData.length > 0 ; else noQuiz">
  <div class="quiz-grid">
    <div class="quiz-card" *ngFor="let quiz of _quizData">
      <span class="status-badge" [ngClass]="quiz.status | lowercase">{{ quiz.status }}</span>

      <div class="card-content">
        <div class="quiz-header-row">
          <div class="icon-title mt-3">
            <img src="assets/images/note02.svg" width="40" height="40" alt="icon" />
			<div class="title-units d-flex align-items-center justify-content-between flex-grow-1">
			<span class="course-title">{{ quiz.quiz_name || "N/A" }}</span>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="quiz.quiz_id && quiz.quiz_name && quiz.status === CourseStatusEnum.Draft"
                    (click)="openEditTitleBox(quiz.quiz_id, quiz.quiz_name, EditableStudyMaterialTypeEnum.Quiz)">
              Edit
            </button>
            <button mat-menu-item *ngIf="quiz.quiz_id"
                    (click)="openDeleteDialogBox(quiz.quiz_id, StudyMaterialTypeEnum.Quiz)">
              Delete
            </button>
          </mat-menu>
        </div>
       </div>
        <div class="details ms-5" *ngIf="quiz.status !== CourseStatusEnum.Draft">
        <span><i class="bi bi-calendar"></i> {{ quiz.published_date | date: 'dd MMM yyyy' }}</span>
        </div>
        <hr />
        <div class="button-wrapper">
          <button class="view-btn" *ngIf="quiz.quiz_id" (click)="goToQuizPage(quiz)">
            <i class="bi" [ngClass]="quiz.status === CourseStatusEnum.Draft ? 'bi-pencil' : 'bi-eye'"></i>
            {{ quiz.status === CourseStatusEnum.Draft ? "Edit Quiz" : "View Quiz" }}
          </button>
		  <button class="view-btn ms-4" (click)="goToStudentQuizResultPage(quiz)" *ngIf="quiz.status === CourseStatusEnum.Published">
			<img src="assets/images/viewResult.png" alt="result-icon" class="img-fluid">View Result
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
 <ng-template #noQuiz>
      <div class="text-center">
        <p>No Quizzes Found</p>
      </div>
      </ng-template>
</ng-template>